import React from 'react';
import { motion } from 'framer-motion';

export const GlowEffect: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <motion.div
      className="relative"
      whileHover={{
        scale: 1.02,
        transition: { duration: 0.2 }
      }}
    >
      <motion.div
        className="absolute inset-0 bg-orange-400 rounded-lg opacity-0 blur-xl"
        animate={{
          opacity: [0, 0.3, 0],
          scale: [0.95, 1.05, 0.95],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      {children}
    </motion.div>
  );
};